import Konva from "konva";
import cloneDeep from "lodash/cloneDeep";
import React, { ReactNode, useEffect, useRef, useState } from "react";

import { v4 as uuidv4 } from "uuid";
import { useRightMenuContext } from "../../../../../hooks/rightMenuContext";
import { useMainHook } from "../../../../../hooks/main";
import api from "../../../../../services/api";
import { useAsidebarEditor } from "../../../hooks/asidebarEditor";
import { useClausesEditor } from "../../../hooks/clausesEditor";
import { useDiff } from "../../../hooks/diffDocuments";
import { usePagesEditor } from "../../../hooks/pagesEditor";
import { useSelection } from "../../../hooks/selection";
import { useSharedDocument } from "../../../hooks/sharedDocument";
import { useWorkspaceEditor } from "../../../hooks/workspaceEditor";
import { automaticSelection } from "../../../utils/automaticSelection";
import { Canvas, FlexDesignArea } from "./styles";

// import { Container } from './styles';
//comiit

interface CanvasMainProps {
  children: ReactNode;
  isSecondUser?: boolean;
}

const CanvasMain: React.FC<CanvasMainProps> = ({ children, isSecondUser }) => {
  const { handleEnterMouse, handleOutside } = useWorkspaceEditor();
  const {
    objectScreen,
    setObjectScreen,
    stageRef,
    dragUrl,
    addToHistory,
    nameOfCurrentUser,
    strokeWidth
  } = useMainHook();
  const { selectedObject, setSelectedObject } = useSelection();
  const { idPage } = usePagesEditor();
  const { setDataPoints, handleShowRightClick } = useRightMenuContext();
  const { grab, setIsGrab } = useAsidebarEditor();
  const [detectChange, setDetectChange] = useState(false);
  const [myId, setMyId] = useState("");
  const {
    draggClauseRef,
    sourceClause,
    clausesObject,
    quillRenderImage,
    dragging,
    setDragging
  } = useClausesEditor();

  const widthClauseRef = useRef(null);
  const heightClauseRef = useRef(null);

  const { hasGroupShared, whichUserEdited } = useDiff();

  const { setIsModalActiveUser } = useSharedDocument();

  useEffect(() => {
    if (objectScreen && myId) {
      automaticSelection({
        setSelectedObject,
        myId,
        stageRef,
        objectScreen,
        idPage
      });
    }
  }, [myId]);

  return (
    <Canvas
      onMouseEnter={handleEnterMouse}
      onMouseLeave={handleOutside}
      style={{ cursor: "default" }}
      onContextMenu={e => {
        handleShowRightClick();
        e.preventDefault();
        setDataPoints(e.pageX, e.pageY);
      }}
      onDrop={async e => {
        if (isSecondUser) {
          return setIsModalActiveUser(true);
        }

        setDragging({ active: false, index: 0 });
        setIsGrab({ active: true });

        if (dragUrl.current.alt) {
          let [instanceObject, object] = dragUrl?.current?.alt?.split("#@@#");

          if (instanceObject === "konvashape") {
            e.preventDefault();
            let cloneStage = cloneDeep(stageRef.current);
            const findStage = cloneStage.find(
              el => el.attrs.id === String(idPage)
            );
            findStage.setPointersPositions(e);
            let id = uuidv4();
            setObjectScreen(prevState => {
              let cloneState = cloneDeep(prevState);
              let myObjectShape = null;

              switch (object) {
                case "rectangle":
                  myObjectShape = {
                    page: String(idPage),
                    object: object,
                    width: 160,
                    height: 100,
                    fill: "#A6A6A6",
                    draggable: true,
                    id: id
                  };
                  break;
                case "circle":
                  myObjectShape = {
                    page: String(idPage),
                    object: object,
                    radius: 70,
                    fill: "#A6A6A6",
                    draggable: true,
                    id: id
                  };
                  break;
                case "simpleLine":
                  myObjectShape = {
                    page: String(idPage),
                    object: object,
                    rotation: 0,
                    strokeWidth: 2,
                    setPoints: 360,
                    stroke: "#A6A6A6",
                    draggable: true,
                    id: id
                  };
                  break;
                case "square":
                  myObjectShape = {
                    page: String(idPage),
                    object: object,
                    width: 100,
                    height: 100,
                    fill: "#A6A6A6",
                    draggable: true,
                    id: id
                  };
                  break;
                case "star":
                  myObjectShape = {
                    page: String(idPage),
                    object: object,
                    numPoints: 5,
                    fill: "#A6A6A6",
                    draggable: true,
                    id: id
                  };
                  break;

                case "triangle2":
                  myObjectShape = {
                    page: String(idPage),
                    object: object,
                    fill: "#A6A6A6",
                    draggable: true,
                    id: id
                  };
                  break;

                case "richTextImage":
                  myObjectShape = {
                    id: id,
                    page: String(idPage),
                    object: object,
                    draggable: true,
                    src: hasGroupShared.current
                      ? "data:image/png;base64,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"
                      : "data:image/png;base64,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",
                    text: "Texto padrão",
                    format: hasGroupShared.current
                      ? {
                          ops: [
                            {
                              attributes: {
                                color: "#9945ee"
                              },
                              insert: "\n"
                            }
                          ]
                        }
                      : {
                          ops: [
                            {
                              insert: "\n"
                            }
                          ]
                        },

                    initialDelta: hasGroupShared.current
                      ? {
                          ops: [
                            {
                              attributes: {
                                color: "#000"
                              },
                              insert: "\n"
                            }
                          ]
                        }
                      : "",
                    textHTML: "",
                    width: 105,
                    height: 18,
                    isModify: hasGroupShared.current ? true : false,
                    nameOfUserEdited: nameOfCurrentUser.current,
                    idOfUserEdited: whichUserEdited.current,
                    isSharedNewText: true
                  };
                  break;

                default:
                  break;
              }
              addToHistory();
              cloneState[idPage - 1].renderObjects.push({
                ...findStage.getPointerPosition(),
                x: findStage.getPointerPosition().x,
                y: findStage.getPointerPosition().y,
                ...myObjectShape
              });

              return cloneState;
            });
            setMyId(id);
            setDetectChange(!detectChange);
            dragUrl.current = "";
          }
          if (instanceObject === "img") {
            addToHistory();
            const myImage = new Image();
            myImage.src = dragUrl.current.src;
            let id = uuidv4();

            //loading image on virtual dom to get width and height, for using to calculate
            //the center of image when dropping on stage.

            let newWidth;
            let newHeight;

            myImage.onload = () => {
              if (myImage.width >= 596 || myImage.height >= 842) {
                let widthRatio = 596 / myImage.width;
                let heightRatio = 842 / myImage.height;
                let bestRatio = Math.min(widthRatio, heightRatio);
                newWidth = myImage.width * bestRatio;
                newHeight = myImage.height * bestRatio;
              } else {
                newWidth = myImage.width;
                newHeight = myImage.height;
              }

              e.preventDefault();
              let cloneStage = cloneDeep(stageRef.current);
              const findStage = cloneStage.find(
                el => el.attrs.id === String(idPage)
              );

              findStage.setPointersPositions(e);
              setObjectScreen(prevState => {
                let cloneState = cloneDeep(prevState);
                cloneState[idPage - 1].renderObjects.push({
                  ...findStage.getPointerPosition(),
                  page: idPage,
                  src: dragUrl.current.src,
                  object: "dropImage",
                  id: id,
                  draggable: true,
                  width: newWidth,
                  height: newHeight,
                  x: 596 / 2 - newWidth / 2,
                  y: 842 / 2 - newHeight / 2
                });

                return cloneState;
              });
              dragUrl.current = "";
              setMyId(id);
            };
          }
          if (instanceObject === "template") {
            e.preventDefault();

            let cloneStage = cloneDeep(stageRef.current);
            const findStage = cloneStage.find(
              el => el.attrs.id === String(idPage)
            );
            try {
              const fetchBitsTemplate = await api.get(
                `bits-templates/${object}`
              );
              let cloneTemplate = cloneDeep(
                fetchBitsTemplate.data.bits_template.template.arrayOfPages
              );
              addToHistory();
              setObjectScreen(cloneTemplate);
              dragUrl.current = "";
            } catch (err) {
              console.log(err);
            }
          }

          if (instanceObject === "icon") {
            e.preventDefault();
            let cloneStages = cloneDeep(stageRef.current);
            const foundStage = cloneStages.find(
              stage => stage.attrs.id === String(idPage)
            );
            foundStage.setPointersPositions(e);
            let id = uuidv4();
            setObjectScreen(prevState => {
              let cloneState = cloneDeep(prevState);
              cloneState[idPage - 1].renderObjects.push({
                ...foundStage.getPointerPosition(),
                page: idPage,
                dpath: dragUrl.current.dpath,
                src: dragUrl.current.src,
                object: "icon",
                id: id,
                stroke: "black",
                draggable: true,
                strokeWidth: Number(strokeWidth.current)
              });
              addToHistory();
              return cloneState;
            });

            setMyId(id);
            dragUrl.current = "";
          } else if (instanceObject === "iconFilled") {
            e.preventDefault();
            let id = uuidv4();
            let cloneStages = cloneDeep(stageRef.current);
            const foundStage = cloneStages.find(
              stage => stage.attrs.id === String(idPage)
            );
            foundStage.setPointersPositions(e);

            setObjectScreen(prevState => {
              let cloneState = cloneDeep(prevState);
              cloneState[idPage - 1].renderObjects.push({
                ...foundStage.getPointerPosition(),
                page: idPage,
                dpath: dragUrl.current.dpath,
                src: dragUrl.current.src,
                object: "icon",
                id: id,
                stroke: "transparent",
                fill: "000",
                draggable: true,
                strokeWidth: Number(strokeWidth.current)
              });
              addToHistory();
              return cloneState;
            });

            setMyId(id);
            dragUrl.current = "";
          }
        } else {
          if (draggClauseRef.current) {
            let id = uuidv4();
            let cloneStages = cloneDeep(stageRef.current);
            const foundStage = cloneStages.find(
              stage => stage.attrs.id === String(idPage)
            );
            foundStage.setPointersPositions(e);

            widthClauseRef.current =
              quillRenderImage.current.getEditor().root.offsetWidth;
            heightClauseRef.current =
              quillRenderImage.current.getEditor().root.offsetHeight;

            let posX = foundStage.getPointerPosition().x;
            let posY = foundStage.getPointerPosition().y;

            setObjectScreen((prevState: any) => {
              let cloneState = cloneDeep(prevState);
              cloneState[idPage - 1].renderObjects.push({
                x: Math.ceil(posX),
                y: Math.ceil(posY - heightClauseRef.current / 2),
                page: idPage,
                id: id,
                text: clausesObject.text,
                format: clausesObject.format,
                src: clausesObject.src,
                width: widthClauseRef.current,
                height: heightClauseRef.current,
                object: "richTextImage",
                draggable: true,
                initialDelta: hasGroupShared.current
                  ? clausesObject.format
                  : "",

                isModify: hasGroupShared.current ? true : false,
                nameOfUserEdited: hasGroupShared.current
                  ? nameOfCurrentUser.current
                  : "",
                idOfUserEdited: hasGroupShared.current
                  ? whichUserEdited.current
                  : "",
                isSharedNewText: hasGroupShared.current ? true : false
              });
              addToHistory();
              return cloneState;
            });

            draggClauseRef.current = null;

            setMyId(id);
          }
        }
      }}
      onDragOver={e => {
        e.preventDefault();
      }}
    >
      <FlexDesignArea>{children}</FlexDesignArea>
    </Canvas>
  );
};

export default CanvasMain;
